var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRamesh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2784 21V9.36364H14.4261C15.3277 9.36364 16.0758 9.51894 16.6705 9.82955C17.2689 10.1402 17.7159 10.5701 18.0114 11.1193C18.3068 11.6648 18.4545 12.2955 18.4545 13.0114C18.4545 13.7235 18.3049 14.3504 18.0057 14.892C17.7102 15.4299 17.2633 15.8485 16.6648 16.1477C16.0701 16.447 15.322 16.5966 14.4205 16.5966H11.2784V15.0852H14.2614C14.8295 15.0852 15.2917 15.0038 15.6477 14.8409C16.0076 14.678 16.2708 14.4413 16.4375 14.1307C16.6042 13.8201 16.6875 13.447 16.6875 13.0114C16.6875 12.572 16.6023 12.1913 16.4318 11.8693C16.2652 11.5473 16.0019 11.3011 15.642 11.1307C15.286 10.9564 14.8182 10.8693 14.2386 10.8693H12.0341V21H10.2784ZM16.0227 15.75L18.8977 21H16.8977L14.0795 15.75H16.0227Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamesh);
export default __webpack_public_path__ + "static/media/ramesh.1b96d6b8cb4ae1fab02f91cf3e3770ae.svg";
export { ForwardRef as ReactComponent };